import React, { useState } from "react";
import { useSelector } from "react-redux";
import PageTemplate from "../../components/pageTemplate/pageTemplate";

function PaymentError() {
  const user = useSelector((state) => state.user);
  const [sidebarClass, setSidebarClass] = useState(
    window.innerWidth > 1023 ? "" : "sidebar-minimize"
  );

  return (
    <PageTemplate>
      <div className="quick-buttons">
        <h1 className="display-title">Payment Failed</h1>
      </div>
      <div className="">
        <h5>
          Your payment couldn't be processed or the transaction was cancelled. 
        </h5>

        <a href="/" style={{ fontSize: '16px', marginTop: '10px'}}>Back to home</a>
      </div>
    </PageTemplate>
  );
}

export default PaymentError;
